import { useEffect, useState } from "react";
import { IOptionFormProps } from "./optionForm";
import { IAutocompleteItem, MenuItemOpionFormTypes } from "../../../../../../../Interfaces/componentTypes";

const useOptionFormHooks = (props: IOptionFormProps) => {
    const { getValues, setValue, addOption, deleteOption, options, update, type } = props;
    const isCreateForm = type === MenuItemOpionFormTypes.CREATE;
    const [addButton, setAddButton] = useState<boolean>(false);
    const [activeIndex, setActiveIndex] = useState<number | undefined>(isCreateForm ? 0 : undefined);
    const [openFormId, setOpenFormId] = useState<number | undefined>(isCreateForm ? 0 : undefined);
    const handleInputChanges = () => {
        const values = getValues();
        const allValid = options.every((_, index) => {
            const measureType = values?.option?.[index]?.measure_type;
            const price = values?.option?.[index]?.price;
            const isMeasureTypeValid = measureType !== null && measureType !== undefined && typeof measureType === 'object';
            const isPriceValid = price !== undefined && price.length > 0;
            return isMeasureTypeValid && isPriceValid;
        });
        setAddButton(allValid);
    };

    const onAddOption = (optionsLength: number) => {
        addOption();
        setOpenFormId(optionsLength)
    };

    const onDeleteOption = (index: number) => {
        deleteOption(index);
        openFormId === index && isCreateForm ? setOpenFormId(prev => prev! - 1) : setOpenFormId(undefined);
        handleInputChanges();
    };

    const onOpenForm = (index: number) => {
        setOpenFormId(index);
        handleInputChanges()
    };

    const handleCheckBox = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const isChecked = e.target.checked;
        if (isChecked) {
            setActiveIndex(index);
            options.forEach((_, optionIndex) => {
                update(optionIndex, {
                    ...options[optionIndex],
                    is_active: optionIndex === index,
                });
                setValue(`option.${optionIndex}.is_active`, optionIndex === index);
            });
        } else if (isCreateForm) {
            options.forEach((_, optionIndex) => {
                update(optionIndex, {
                    ...options[optionIndex],
                    is_active: optionIndex === 0,
                });
                setValue(`option.${optionIndex}.is_active`, optionIndex === 0);
            });
        }

        handleInputChanges();
    };

    const updateMeasureType = (index: number, newMeasureType: IAutocompleteItem) => {
        update(index, {
            ...options[index],
            measure_type: newMeasureType,
        });
        handleInputChanges()
    };

    const updateMeasureValue = (index: number, newMeasureValue: string) => {
        update(index, {
            ...options[index],
            measure_value: newMeasureValue,
        });
        handleInputChanges()
    };

    const updatePrice = (index: number, price: string) => {
        update(index, {
            ...options[index],
            price: price,
        });
        handleInputChanges()
    };

    const updatePackageCost = (index: number, price: string) => {
        update(index, {
            ...options[index],
            package_cost: price,
        });
        handleInputChanges()
    };

    useEffect(() => {
        handleInputChanges()
    }, [options]);

    useEffect(() => {
            const isAnyActive = options.some((_, optionIndex) => getValues(`option.${optionIndex}.is_active`));
            if (!isAnyActive) {
                update(0, {
                    ...options[0],
                    is_active: true,
                });
                setValue(`option.0.is_active`, true);
                setActiveIndex(0)
            }
    }, [options, getValues, setValue]);

    return {
        addButton,
        openFormId,
        activeIndex,
        onOpenForm,
        onAddOption,
        updatePrice,
        handleCheckBox,
        onDeleteOption,
        updateMeasureType,
        updatePackageCost,
        updateMeasureValue,
    }
};

export default useOptionFormHooks